import React, { useState, useEffect, Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { Button, MenuItem, Select, SelectChangeEvent, Box } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useExportUsers } from "../../api/hooks/useUser";
import { showSuccess, showError } from "../../helpers/toast";
import type { GetUsersParams } from "../../api/types/user.types";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AddIcon from '@mui/icons-material/Add';

interface UserTopbarProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  isBlockedFilter?: boolean | undefined;
  setIsBlockedFilter: (value: boolean | undefined) => void;
}

const UserTopbar: React.FC<UserTopbarProps> = ({
  searchTerm,
  setSearchTerm,
  isBlockedFilter,
  setIsBlockedFilter,
}) => {
  const navigate = useNavigate();
  const [Status, setStatus] = React.useState<string>('all');

  const handleStatusChange = (event: SelectChangeEvent) => {
    const value = event.target.value as string;
    setStatus(value);
    if (value === 'all') {
      setIsBlockedFilter(undefined);
    } else if (value === 'blocked') {
      setIsBlockedFilter(true);
    } else if (value === 'active') {
      setIsBlockedFilter(false);
    }
  };

  // Export users mutation
  const { mutate: exportUsers, isPending: isExporting } = useExportUsers({
    onSuccess: (blob: Blob) => {
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `users_export_${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      showSuccess("Users exported successfully");
    },
    onError: (error: any) => {
      showError(error?.response?.data?.message || "Failed to export users");
    },
  });

  const handleExport = () => {
    const params: GetUsersParams = {};
    if (searchTerm.trim()) {
      params.search = searchTerm.trim();
    }
    if (isBlockedFilter !== undefined) {
      params.isBlocked = isBlockedFilter;
    }
    exportUsers(params);
  };

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            value={searchTerm}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
            onCross={() => setSearchTerm("")}
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search by name, email, phone..."
          />
          {/* <Box sx={{ minWidth: 150, ml: 2 }}>
            <Select
              value={Status}
              onChange={handleStatusChange}
              displayEmpty
              fullWidth
              sx={{ height: '40px' }}
            >
              <MenuItem value="all">All Users</MenuItem>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="blocked">Blocked</MenuItem>
            </Select>
          </Box> */}
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-users/add")}
            startIcon={<AddIcon />}
          >
            Add User
          </Button>
          <Button
            className="btn btn_primary"
            onClick={handleExport}
            disabled={isExporting}
            startIcon={<FileDownloadIcon />}
            style={{ marginLeft: 8 }}
          >
            {isExporting ? "Exporting..." : "Export CSV"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default UserTopbar;
